export default {
  name: 'RtContainer',
  render(h) {
    return h(
      'el-container',
      {
        attrs: this.$attrs,
        ['class']: 'rt-container'
      },
      this.$slots.default
    );
  }
};


// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/layout/rtContainer.js